import { createFileRoute } from '@tanstack/react-router'
import ProjectFloorplanPage from '@/spa/pages/projects/ProjectFloorplanPage'
import { routeErrorComponent } from '../../_shared/RouteError'

export const Route = createFileRoute('/projects/$id/floorplan')({
  component: ProjectFloorplanPage,
  errorComponent: routeErrorComponent,
})
